<!-- 首页 -->
<template>
    <div class="homeMain">
        <el-carousel trigger="click" height="43vw">
            <!-- <el-carousel-item v-for="item in pictureList" :key="item"> -->
            <el-carousel-item v-for="item in pictureLang[$i18n.locale]" :key="item">
                <img :src="item" class="homeImg">
            </el-carousel-item>
        </el-carousel>

        <!-- 博商管理科学研究院 homeVideo -->
        <div class="homeContent">
            <div class="homeTitle" style="" v-html="$t('homeVideo.homeTitle1')">

            </div>
            <div class="homeArrows">
                <img src="../assets/image/home/arrows.png">
            </div>
            <div class="homeText" style="margin-bottom: 30px;" v-html="$t('homeVideo.homeText1')"> </div>
            <div class="homeText" v-html="$t('homeVideo.homeText1_1')"> </div>
            <div class="homeShow">
                <router-link :to="{ path: '/about' }">
                    <div class="homeShowMore">{{ $t('homeCommon.showMore') }} <i class="el-icon-caret-right rightRed"></i></div>
                </router-link>
                <div class="homeVideoContent">
                    <ul class="homeVideoLeft">
                        <li>
                            <img class="homeIcon" src="../assets/image/home/首页-icon/1.svg" alt="">
                            <!-- <div>
                                <span class="homeNum">1个</span>
                                <span>OMO学习平台</span>
                            </div> -->
                            <div v-html="$t('homeVideo.homeVideoLeft1')">
                            </div>
                        </li>
                        <li>
                            <img class="homeIcon" src="../assets/image/home/首页-icon/2.svg" alt="">
                            <div v-html="$t('homeVideo.homeVideoLeft2')">
                            </div>
                        </li>
                        <li>
                            <img class="homeIcon" src="../assets/image/home/首页-icon/3.svg" alt="">
                            <div v-html="$t('homeVideo.homeVideoLeft3')">
                            </div>
                        </li>
                    </ul>
                    <div class="homeVideo">
                        <video controls preload="auto" muted autoplay :src="videoList[$i18n.locale]"></video>
                    </div>
                </div>
            </div>
        </div>
        <!-- 师资阵容 homeTeacher-->
        <div class="homeContent">
            <div class="homeTitle" v-html="$t('homeTeacher.homeTitle2')">
            </div>
            <div class="homeArrows">
                <img src="../assets/image/home/arrows.png">
            </div>
            <div class="homeText">
                {{ $t('homeTeacher.homeText2') }}
                <!-- 博商所有导师均为国内外知名专家或咨询师，在专业领域平均有15年以上的实战经验和学术研究，人均授课辅导超过50家企业，拥有十分硬核的实战落地经验。迄今为止，博商已打造100位 -->
            </div>
            <div class="homeShow">
                <router-link :to="{ path: '/combat' }">
                    <div class="homeShowMore">{{ $t('homeCommon.showMore') }} <i class="el-icon-caret-right rightRed"></i></div>
                </router-link>
                <div class="homeTeacherContent">
                    <div>
                        <router-link :to="{ path: '/combat' }">
                            <ul></ul>
                            <img src="https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914269795598094320093037648.png'" alt="">
                            <span class="fsHome">{{ $t('homeTeacher.homeTeacherContent1') }}
                                <!-- <i class="el-icon-arrow-right iconTeacher"></i> -->
                            </span>
                        </router-link>
                    </div>
                    <div>
                        <router-link :to="{ path: '/combat' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('homeTeacher.homeTeacherContent2') }}
                                <!-- <i class="el-icon-arrow-right iconTeacher"></i> -->
                            </span>
                        </router-link>
                    </div>
                    <div>
                        <router-link :to="{ path: '/combat' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('homeTeacher.homeTeacherContent3') }}
                                <!-- <i class="el-icon-arrow-right iconTeacher"></i> -->
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- 实战课程 -->
        <div class="homeContent">
            <div class="homeTitle" v-html="$t('homeCourse.homeTitle3')">

            </div>
            <div class="homeArrows">
                <img src="../assets/image/home/arrows.png">
            </div>
            <div class="homeText">
                {{ $t('homeCourse.homeText3') }}

            </div>
            <div class="homeShow">
                <router-link :to="{ path: '/course' }">
                    <div class="homeShowMore">{{ $t('homeCommon.showMore') }} <i class="el-icon-caret-right rightRed"></i></div>
                </router-link>
                <div class="homeCourse">
                    <ul class="homeCourseLeft">
                        <li>
                            <router-link :to="{ path: '/courseServer/personalLearning' }">
                                <div></div>
                                <span class="fsHome">{{ $t('home.text1') }} <i class="el-icon-arrow-right iconTeacher"></i></span>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ path: '/courseServer/teamLearning' }">
                                <div></div>
                                <span class="fsHome">{{ $t('home.text2') }}<i class="el-icon-arrow-right iconTeacher"></i></span>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ path: '/courseServer/accompanyRunners' }">
                                <div></div>
                                <span class="fsHome">{{ $t('home.text3') }} <i class="el-icon-arrow-right iconTeacher"></i></span>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ path: '/courseServer/lead' }">
                                <div></div>
                                <span class="fsHome">{{ $t('home.text4') }}<i class="el-icon-arrow-right iconTeacher"></i></span>
                            </router-link>
                        </li>
                    </ul>
                    <div class="homeCourseRight">
                        <router-link :to="{ path: '/courseServer/onLine' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('home.text5') }} <i class="el-icon-arrow-right iconTeacher"></i></span>
                        </router-link>
                    </div>
                </div>
            </div>


        </div>
        <!-- 企业学员 -->
        <div class="homeContent">
            <div class="homeTitle">
                <span>{{ $t('home.text6') }}</span>
            </div>
            <div class="homeArrows">
                <img src="../assets/image/home/arrows.png">
            </div>
            <div class="homeText">
                {{ $t('home.text7') }}
            </div>
            <div class="homeShow">
                <router-link :to="{ path: '/student' }">
                    <div class="homeShowMore">{{ $t('homeCommon.showMore') }} <i class="el-icon-caret-right rightRed"></i></div>
                </router-link>
                <div class="homeStudentsContent">
                    <div>
                        <router-link :to="{ path: '/student' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('home.text8') }}
                                <i class="el-icon-arrow-right iconTeacher"></i>
                            </span>
                        </router-link>
                    </div>
                    <div>
                        <router-link :to="{ path: '/student' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('home.text9') }}
                                <i class="el-icon-arrow-right iconTeacher"></i>
                            </span>
                        </router-link>
                    </div>
                    <div>
                        <router-link :to="{ path: '/student' }">
                            <ul></ul>
                            <span class="fsHome">{{ $t('home.text10') }}
                                <i class="el-icon-arrow-right iconTeacher"></i>
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- 合作优势 -->
        <div class="homeContent" style="margin-bottom: 205px;">
            <div class="homeTitle">
                <span>{{ $t('home.text11') }}</span>
            </div>
            <div class="homeArrows">
                <img src="../assets/image/home/arrows.png">
            </div>
            <div class="homeText">
                {{ $t('home.text12') }}
            </div>
            <div class="homeShow">
                <router-link :to="{ path: '/join' }">
                    <div class="homeShowMore">{{ $t('homeCommon.showMore') }} <i class="el-icon-caret-right rightRed"></i></div>
                </router-link>
                <div class="homeAdvantage">
                    <div class="homeAdvantageCon">
                        <img src="https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914271506169847454797091422.png" alt="">
                        <div class="homeAdvantageTitle"> {{ $t('home.text13') }}</div>
                        <div class="homeAdvantageText">
                            {{ $t('home.text14') }}
                        </div>
                    </div>
                    <div class="homeAdvantageCon">
                        <img src="https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1691427150617185494951429223.png" alt="">
                        <div class="homeAdvantageTitle"> {{ $t('home.text15') }}</div>
                        <div class="homeAdvantageText"> {{ $t('home.text16') }}</div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import initSeo from '@/api/seoApi'
export default {
    name: "home",
    data() {
        return {
            pictureList: [
                "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685072680039073284324.png",
                "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685029010190236984112.png",
                "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685088866730027769407.png",
                "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685085974225079448188.png"
            ],
            pictureLang: {
                en: [
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920982531917790364393567821.jpg",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1692098253187215402915060543.jpg",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920982531916401982004699582.jpg",
                ],
                ja: [
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920984304941696596516298956.jpg",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920984304905296627325085674.jpg",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1692098430494670773731254513.jpg",
                ],
                "zh-cn": [
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685029010190236984112.png",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685072680039073284324.png",
                    "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914247685088866730027769407.png",
                ],
            },
            videoList: {
                en: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/%E5%8D%9A%E5%95%86%E5%93%81%E7%89%8C%E4%BB%8B%E7%BB%8D%E7%89%87%EF%BC%88%E8%8B%B1%E6%96%87%E7%89%88%EF%BC%89.mp4",
                ja: "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/%E5%8D%9A%E5%95%86%E5%93%81%E7%89%8C%E4%BB%8B%E7%BB%8D%E7%89%87%EF%BC%88%E6%97%A5%E6%96%87%E7%89%88%EF%BC%89.mp4",
                "zh-cn": "https://bosumjs.oss-cn-shenzhen.aliyuncs.com/website/%E5%8D%9A%E5%95%86%E5%93%81%E7%89%8C%E4%BB%8B%E7%BB%8D%E7%89%87%EF%BC%88%E4%B8%AD%E6%96%87%E7%89%88%EF%BC%89.mp4",
            },
        }
    },

    mounted() {
        this.seoConFun("home");
    },
    methods: {
        seoConFun(val) {
            initSeo.seoConFromStatic(val);
        }
    }
}
</script>
<style lang="scss">
@import "@/assets/styles/variable.scss";

.homeMain {
    // height: 800px;
    width: 100%;

    // background-color: #ccc;


    .homeContent {
        width: 1200px;
        margin: 0 auto;
        // background-color: rgba(228, 109, 228, 0.3);
        margin-top: 119px;
    }

    .homeImg {
        width: 100%;
        height: 43vw;
    }

    .homeArrows {
        text-align: center;
        margin-top: 26px;
        margin-bottom: 40px;

        img {
            width: 139px;
            height: 11px;
        }
    }

    .homeTitle {
        font-size: 24px;
        font-weight: bold;
        color: #555555;
        text-align: center;
        padding: 0 100px;
        // margin-bottom: 60px;
        line-height: 40px;

        span {
            color: $redColor;

        }
    }

    .homeText {
        padding: 0 100px;
        color: #555555;
        font-size: 14px;
        font-weight: 400;
        text-align: center;
        margin-bottom: 60px;
        line-height: 29px;
        ;
    }

    .homeShow {
        // height: 470px;
        width: 100%;
        background-color: #F3F2F2;
        padding: 41px 100px 37px 100px;

        .homeShowMore {
            // float: right;
            cursor: pointer;
            text-align: right;
            margin-bottom: 10px;
        }

        .homeVideoContent {
            height: 360px;
            display: flex;
        }

        .homeVideoLeft {
            height: 100%;
            width: 350px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: 16px 0;

            li {
                display: flex;
                align-items: center;
                font-size: 16px;
                font-weight: bold;
                color: #555555;
            }

            .homeIcon {
                width: 36px;
                height: 36px;
                margin-right: 37px;
            }

            .homeNum {
                color: $redColor;
            }

            div {
                line-height: 24px;
            }
        }

        .homeVideo {
            width: 640px;
            height: 100%;
            margin-left: 90px;

            video {
                width: 100%;
                height: 100%;
                object-fit: fill;
            }
        }

        .homeStudentsContent {
            width: 100%;
            height: 200px;
            display: flex;

            ul {
                width: 100%;
                height: 100%;
                background: #000000;
                opacity: 0.7;
                position: absolute;
                z-index: 10;
                display: none;
            }



            div {
                display: inline-block;
                width: 320px;
                height: 100%;
                // background-color: rgba(228, 109, 228, 0.3);
                position: relative;

                &:nth-child(1) {
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914269795598094320093037648.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }

                &:nth-child(2) {
                    margin: 0 20px;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169142697956039154100798626734.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }

                &:nth-child(3) {
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169142697956028578915522169557.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }

                span {
                    // display: inline-block;
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 10px;
                    width: 100%;
                    background: $redColor;
                    opacity: 0.8;
                    position: absolute;
                    bottom: 0;
                    height: 36px;
                    // line-height: 36px;
                    color: #fff;

                }

                .iconTeacher {
                    cursor: pointer;
                    background-color: #fff;
                    color: $redColor;
                    border-radius: 16px;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    font-size: 12px;
                    padding-left: 3px;
                    font-weight: 700;

                }
            }

        }

        .homeTeacherContent {
            width: 100%;
            height: 200px;
            display: flex;

            ul {
                width: 320px;
                height: 100%;
                background: #000000;
                opacity: 0.7;
                position: absolute;
                z-index: 10;
                display: none;
            }


            div {
                display: inline-block;
                width: 320px;
                height: 100%;
                // background-color: rgba(228, 109, 228, 0.3);
                position: relative;

                &:nth-child(1) {
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914263533202726089682483601.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }

                &:nth-child(2) {
                    margin: 0 20px;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169142635332118265313272097794.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }

                &:nth-child(3) {
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914263533216346049188361551.png');
                    background-size: 100% 100%;

                    &:hover {
                        ul {
                            display: block
                        }
                    }
                }



                span {
                    // display: inline-block;
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 6px;
                    width: 100%;
                    background: $redColor;
                    opacity: 0.8;
                    position: absolute;
                    bottom: 0;
                    height: 36px;
                    line-height: 36px;
                    color: #fff;

                }

                .iconTeacher {
                    cursor: pointer;
                    background-color: #fff;
                    color: $redColor;
                    border-radius: 16px;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    font-size: 12px;
                    padding-left: 3px;
                    font-weight: 700;

                }
            }

        }

        .homeCourse {
            width: 100%;
            height: 420px;

            display: flex;

        }

        .homeCourseLeft {
            width: 660px;
            height: 100%;

            div {
                width: 100%;
                height: 100%;
                position: absolute;
                display: none;
                background: #000000;
                opacity: 0.7;
                z-index: 11;
            }

            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: repeat(4, 1fr);
            grid-template-areas: "a1 a1 a2 a2"
            "a1 a1 a2 a2"
            "a3 a3 a4 a4"
            "a3 a3 a4 a4"
            ;
            row-gap: 20px;
            column-gap: 20px;


            li {

                display: inline-block;
                width: 100%;
                height: 100%;

                position: relative;

                &:hover {
                    div {

                        display: inline-block;
                    }
                }

                &:nth-child(1) {
                    grid-area: a1;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914266619875022479259893944.png');
                    background-size: 100% 100%;
                }

                &:nth-child(2) {
                    grid-area: a2;
                    // margin: 0 20px;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169142666198746321864514075184.png');
                    background-size: 100% 100%;
                }

                &:nth-child(3) {
                    grid-area: a3;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169142666198705619679247928411.png');
                    background-size: 100% 100%;
                }

                &:nth-child(4) {
                    grid-area: a4;
                    background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16914266619875119470293780859.png');
                    background-size: 100% 100%;
                }

                span {
                    // display: inline-block;
                    display: inline-flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 10px;
                    width: 100%;
                    background: $redColor;
                    opacity: 0.8;
                    position: absolute;
                    bottom: 0;
                    height: 36px;
                    line-height: 36px;
                    color: #fff;

                }

                .iconTeacher {
                    cursor: pointer;
                    background-color: #fff;
                    color: $redColor;
                    border-radius: 16px;
                    width: 16px;
                    height: 16px;
                    line-height: 16px;
                    text-align: center;
                    font-size: 12px;
                    padding-left: 3px;
                    font-weight: 700;


                }
            }


        }

        .homeCourseRight {
            height: 100%;
            width: 320px;
            margin-left: 20px;
            position: relative;

            // background-color: rgba(228, 109, 228, 0.3);
            background-image: url('https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1691426661987989205544417314.png');
            background-size: 100% 100%;

            ul {
                width: 100%;
                height: 100%;
                position: absolute;
                display: none;
                background: #000000;
                opacity: 0.7;
                z-index: 11;
            }

            &:hover {
                ul {

                    display: inline-block;
                }
            }

            span {
                // display: inline-block;
                display: inline-flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 10px;
                width: 100%;
                background: $redColor;
                opacity: 0.8;
                position: absolute;
                bottom: 0;
                height: 36px;
                line-height: 36px;
                color: #fff;

            }

            .iconTeacher {
                cursor: pointer;
                background-color: #fff;
                color: $redColor;
                border-radius: 16px;
                width: 16px;
                height: 16px;
                line-height: 16px;
                text-align: center;
                font-size: 12px;
                padding-left: 3px;
                font-weight: 700;


            }
        }

        .homeAdvantage {
            width: 100%;
            // height: 360px;
            display: flex;

            .homeAdvantageCon {
                display: inline-block;
                width: 50%;
                background-color: #fff;
                padding-bottom: 20px;

                img {
                    width: 100%;
                    height: 260px;
                    border-bottom: 2px solid #D31319;
                }

                &:nth-child(2) {
                    margin-left: 30px;
                }

            }

            .homeAdvantageTitle {
                font-size: 16px;
                font-weight: bold;
                color: #555555;
                margin-top: 24px;
                margin-bottom: 9px;
                padding: 0 10px;
            }

            .homeAdvantageText {
                padding: 0 10px;
                width: 100%;
                font-size: 12px;
                font-weight: 400;
                color: #979797;
                line-height: 20px;
                ;
            }
        }



    }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue